module.exports = __webpack_public_path__ + "static/media/favicons_pinduoduo.c5743913.png";